var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1625_10270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1429 3.19922H5.02136C3.2837 3.19922 1.875 4.60792 1.875 6.34563V17.2417C1.875 18.9794 3.2837 20.388 5.02136 20.388H15.1429C16.8806 20.388 18.2893 18.9793 18.2893 17.2417V6.34563C18.2893 4.60792 16.8806 3.19922 15.1429 3.19922Z",
    fill: "#CF966F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15856 18.5139C4.37582 18.5139 3.73904 17.8772 3.73904 17.0945V6.49373C3.73904 5.71099 4.37582 5.07422 5.15856 5.07422H15.0058C15.7885 5.07422 16.4253 5.71099 16.4253 6.49373V17.0945C16.4253 17.8772 15.7884 18.5139 15.0058 18.5139H5.15856Z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6609 2.10778H11.6899C11.6899 1.21983 10.9701 0.5 10.0822 0.5C9.19422 0.5 8.47439 1.21983 8.47439 2.10778H6.50341C5.87949 2.10778 5.37371 2.61356 5.37371 3.23747V4.39458C5.37371 5.0185 5.87949 5.52427 6.50341 5.52427H13.6609C14.2848 5.52427 14.7906 5.0185 14.7906 4.39458V3.23747C14.7906 2.61356 14.2848 2.10778 13.6609 2.10778Z",
    fill: "#BEB9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52699 9.57552C6.45903 9.57552 6.3915 9.55376 6.33516 9.51121C6.23717 9.43714 6.19055 9.31332 6.21537 9.19301L6.40448 8.27733C6.44003 8.10523 6.60822 7.99455 6.78041 8.0301C6.95247 8.06565 7.06318 8.23393 7.02763 8.40603L6.97397 8.66577L8.1379 8.0595C8.2938 7.97831 8.48588 8.03884 8.56707 8.19469C8.64826 8.35054 8.58773 8.54267 8.43188 8.62386L6.67393 9.53955C6.62761 9.56364 6.57717 9.57552 6.52699 9.57552Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6615 9.11678H9.90137C9.72566 9.11678 9.58321 8.97433 9.58321 8.79862C9.58321 8.62292 9.72566 8.48047 9.90137 8.48047H12.6615C12.8372 8.48047 12.9797 8.62292 12.9797 8.79862C12.9797 8.97433 12.8372 9.11678 12.6615 9.11678Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52699 12.5677C6.45904 12.5677 6.3915 12.5459 6.33517 12.5034C6.23718 12.4293 6.19056 12.3055 6.21537 12.1852L6.40448 11.2695C6.44003 11.0974 6.60823 10.9868 6.78041 11.0223C6.95247 11.0578 7.06319 11.2261 7.02764 11.3982L6.97398 11.658L8.13791 11.0517C8.2938 10.9705 8.48588 11.031 8.56708 11.1869C8.64827 11.3427 8.58773 11.5349 8.43188 11.616L6.67394 12.5317C6.62761 12.5558 6.57718 12.5677 6.52699 12.5677Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6615 12.1109H9.90137C9.72566 12.1109 9.58321 11.9685 9.58321 11.7928C9.58321 11.6171 9.72566 11.4746 9.90137 11.4746H12.6615C12.8372 11.4746 12.9797 11.6171 12.9797 11.7928C12.9797 11.9685 12.8372 12.1109 12.6615 12.1109Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52699 15.5618C6.45904 15.5618 6.3915 15.5401 6.33517 15.4975C6.23718 15.4235 6.19056 15.2996 6.21537 15.1793L6.40448 14.2637C6.44003 14.0916 6.60823 13.9809 6.78041 14.0164C6.95247 14.052 7.06319 14.2203 7.02764 14.3924L6.97398 14.6521L8.13791 14.0458C8.2938 13.9646 8.48588 14.0252 8.56708 14.181C8.64827 14.3369 8.58773 14.529 8.43188 14.6102L6.67394 15.5259C6.62761 15.55 6.57718 15.5618 6.52699 15.5618Z",
    fill: "#43404F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6615 15.1031H9.90137C9.72566 15.1031 9.58321 14.9607 9.58321 14.785C9.58321 14.6092 9.72566 14.4668 9.90137 14.4668H12.6615C12.8372 14.4668 12.9797 14.6092 12.9797 14.785C12.9797 14.9607 12.8372 15.1031 12.6615 15.1031Z",
    fill: "#43404F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1625_10270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.e337ecd45bfc50a1105dff9c41f309e5.svg";
export { ForwardRef as ReactComponent };